/**
 * Splits a string into an array of non-empty strings
 */
export default function splitAndTrim(value: string): Array<string> {
  return value
    .split(',')
    .map(value => value.trim())
    .filter(Boolean);
}
